<template>
  <div class="mt-2 pb-2">
    <!-- Data Source -->
    <h5>
      Data Source
      <i
        class="feather icon-info"
        @click="showHelp('dataSource')"
      />
    </h5>
    <small class="text-muted">{{ `Max data sources allowed for this panel is ${maxDataSources}` }}</small>

    <!-- Row Loop -->
    <b-row
      v-for="(dataSource, index) in panelconfig.dataSources"
      :id="dataSource.rowId"
      :key="dataSource.rowd"
      class="mt-2 ml-2 border-bottom pb-2 mb-2"
    >
      <b-col
        cols="1"
        class="mt-2 border-right"
      >
        <h1>{{ index +1 }}</h1>
      </b-col>

      <b-col
        cols="2"
        class=" border-right"
      >
        <h6>Select Entity</h6>
        <v-select
          v-model="panelconfig.dataSources[index].dataSourceType"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          :reduce="dataSourceType => dataSourceType.value"
          :options="dataSourceTypes"
        />
      </b-col>

      <div v-if="panelconfig.dataSources[index].dataSourceType !== undefined">
        <b-col
          class="border-right"
        >
          <h6>{{ "Choose " + panelconfig.dataSources[index].dataSourceType }}</h6>
          <v-select
            v-model="panelconfig.dataSources[index].id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :reduce="dataSource => dataSource.id"
            :options="dataSources[panelconfig.dataSources[index].dataSourceType]"
            @input="selectDataSource(dataSource.rowId)"
          />
        </b-col>
      </div>

      <div v-if="panelconfig.dataSources[index].id !== undefined">
        <b-col
          class="border-right"
        >
          <h6>Data Field</h6>
          <v-select
            v-model="panelconfig.dataSources[index].sensorId"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :reduce="dataField => dataField.id"
            :options="rowDataFields[index] ? rowDataFields[index].dataFields : []"
          />
        </b-col>
      </div>

      <!-- Remove Button -->
      <b-col
        v-if="panelconfig.dataSources.length > 1 && index !== 0"
        class="mb-50"
      >
        <b-button
          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
          variant="outline-danger"
          class="mt-0 mt-md-2"
          @click="removeItem(index)"
        >
          <feather-icon
            icon="XIcon"
            class="mr-25"
          />
          <span>Delete</span>
        </b-button>
      </b-col>

    </b-row>

    <!-- Add Button -->
    <div v-if="panelconfig.dataSources.length < maxDataSources">
      <b-row class="justify-content-center">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="repeateAgain"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          <span>Add Datasource</span>
        </b-button>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { API } from 'aws-amplify'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import * as queries from '../../../graphql/queries'

export default {
  components: {
    BCol,
    BRow,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    panelconfig: {
      type: Object,
      required: true,
    },
    maxDataSources: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dataFields: [],
      siteHover: false,
      objectHover: false,
      deviceHover: false,
      dataSourceType: false,
      dataSources: {
        device: [],
        objects: [],
      },
      rowDataFields: [],
      deviceModelSensors: [],
      dataSourceTypes: [
        { name: 'Device', value: 'device' }, { name: 'Object', value: 'object' }, { name: 'Site', value: 'site' },
      ],
      colors: [
        'primary', 'success', 'info', 'warning', 'danger',
      ],
      selected: null,
      statistic: '86%',
      option: [
        { title: 'CPU Icon', id: 'CpuIcon' },
        { title: 'Square Icon', id: 'SquareIcon' },
        { title: 'Battery Icon', id: 'BatteryIcon' },
      ],
      nextTodoId: 2,
    }
  },

  async created() {
    await this.listDevices()
    // this.listObjects()
    this.initTrHeight()
    if (this.panelconfig.dataSources.length > 0) {
      this.panelconfig.dataSources.forEach(dataSource => {
        this.rowDataFields.push({
          dataFields: [],
        })
        this.selectDataSource(dataSource.rowId)
      })
    }
  },
  methods: {
    repeateAgain() {
      this.panelconfig.dataSources.push({
        rowId: this.nextTodoId += this.nextTodoId,
      })
    },
    removeItem(index) {
      this.panelconfig.dataSources.splice(index, 1)
      this.rowDataFields.splice(index, 1)
    },
    initTrHeight() {
      this.trSetHeight(null)
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    resetModal() {
      if (this.panelconfig.dataSources.length > 0) {
        this.items = []
        this.objectProperties.forEach((property, index) => {
          this.items.push({
            rowId: index + 1,
            property,
          })
        })
      } else {
        this.items = [{
          rowId: 1,
          property: {
            id: '',
            name: '',
            value: '',
            unit: '',
          },
        }]
      }
    },
    async listDevices(nextToken) {
      const workspace = JSON.parse(localStorage.getItem('workspace')).id
      const response = await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace,
          nextToken,
        },
      })

      const devices = response.data.getWorkspace.devices.items
      if (devices.length > 0) {
        this.dataSources.device.push(...devices)
        if (response.data.getWorkspace.devices.nextToken) {
          await this.listDevices(response.data.getWorkspace.devices.nextToken)
        }
      }
    },
    async listObjects(nextToken) {
      const workspace = JSON.parse(localStorage.getItem('workspace')).id
      await API.graphql({
        query: queries.listObjects,
        variables: {
          filter: { workspace: { eq: workspace } },
          nextToken,
        },
      }).then(async response => {
        if (this.dataSources.objects.length === 0) {
          this.dataSources.objects = response.data.listObjects.items
        } else if (this.objects.length > 0) {
          this.dataSources.objects.push(...response.data.listObjects.items)
        }
        if (response.data.listObjects.nextToken) {
          this.listObjects(response.data.listObjects.nextToken)
        }
      })
    },
    selectDataSource(dataSourceRowid) {
      let rowIndex = ''
      this.panelconfig.dataSources.forEach((dataSource, index) => {
        if (dataSource.rowId === dataSourceRowid) {
          rowIndex = index
          // listSensors for that row
          this.rowDataFields.push({
            id: dataSource.id,
            dataFields: [],
          })
          this.listSensors(rowIndex)
        }
      })
    },
    async listSensors(index) {
      let deviceModelDevicesId = ''
      this.dataSources.device.forEach(device => {
        if (device.id === this.panelconfig.dataSources[index].id) {
          deviceModelDevicesId = device.deviceModelDevicesId
        }
      })
      await API.graphql({
        query: queries.listDeviceModelSensors,
        variables: {
          filter: { deviceModelID: { eq: deviceModelDevicesId } },
        },
      }).then(response => {
        const deviceModelSensors = response.data.listDeviceModelSensors.items
        deviceModelSensors.forEach(item => {
          this.deviceModelSensors.push(item.sensor)
          this.rowDataFields.forEach(row => {
            if (row.id === this.panelconfig.dataSources[index].id) {
              this.rowDataFields[index].dataFields.push(item.sensor)
            }
          })
        })
      })
    },
    selectDataField() {
    },
  },
}
</script>

<style>

</style>
